import React from 'react'
import { useIntl } from 'react-intl'
import { connect } from 'react-redux'
import VerticalSpacer from 'components/Common/Spacing/VerticalSpacer'
import HighIntentOffersCarousel from 'components/OfferList/HighIntent/HighIntentOffersCarousel'
import { getHighIntentTourOffers } from 'selectors/recomendations/highIntentSelectors'
import HeadingTextBlock from 'LuxKit/TextBlocks/HeadingTextBlock'
import config from 'constants/config'
import Pane from 'components/Common/Pane'
import LayoutContainer from 'components/Common/LayoutContainer/LayoutContainer'

interface Props {
  highIntentOffers: Array<App.HighIntentOffer>
}

function ToursPageHighIntentTours(props: Props) {
  const { highIntentOffers } = props
  const intl = useIntl()

  if (highIntentOffers.length === 0 || !config.LERE_HIGH_INTENT_CAROUSEL_ENABLED) {
    return null
  }

  return <LayoutContainer><Pane>
    <VerticalSpacer gap={12}>
      <HeadingTextBlock variant="heading5">{intl.formatMessage({
        id: 'HFgl8j68x4',
        defaultMessage: 'Still interested in these tours?',
        description: 'Heading for high-intent tours carousel on tours page',
      })}
      </HeadingTextBlock>
      <HighIntentOffersCarousel
        highIntentOffers={highIntentOffers}
        analyticsLabel="tours"
      />
    </VerticalSpacer>
  </Pane>
  </LayoutContainer>
}

function mapStateToProps(state: App.State) {
  return {
    highIntentOffers: getHighIntentTourOffers(state),
  }
}

export default connect(mapStateToProps)(ToursPageHighIntentTours)
